import React from 'react';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import PropTypes from 'prop-types';
// Models
import mScenario from 'models/scenario';
// Core components
import Box from 'components/core/Box';
import Timeline from 'components/core/timeline/Timeline';
// Custom
import { deviceDataShape, scenarioActionDataShape } from 'constants/PropTypesShapes';
import { EditIconButton, DeleteIconButton } from 'components/buttons/IconButtons';
import ActionItemElementItem from './ActionItemElementItem';

const ActionItem = ({
  action, device, showActionButtons, disableActionButtons, active, onEdit, onDelete,
}) => {
  // Build array of all actions
  const actionsArray = mScenario.actionAndTreeToArray(action);

  // Now build timeline items
  const timelineItems = _map(actionsArray, (actionElement) => {
    const delaySeconds = actionElement.delay / 10;

    return {
      id: _toString(actionElement.id),
      label: `${delaySeconds} s`,
      iconId: 'tlEvent',
      content: <ActionItemElementItem action={actionElement} device={device} />,
    };
  });

  return (
    <Box type="highlightable" highlighted={active}>
      {!!device && (
        <div style={{ position: 'relative' }}>
          <Timeline
            startItem={{
              iconId: 'tlStart',
            }}
            items={timelineItems}
          />
          {showActionButtons && (
            <div className="d-flex" style={{ position: 'absolute', top: 4, right: 4 }}>
              <EditIconButton onClick={() => onEdit(action)} disabled={disableActionButtons} />
              <DeleteIconButton onClick={() => onDelete(action)} disabled={disableActionButtons} />
            </div>
          )}
        </div>
      )}
    </Box>
  );
};

ActionItem.propTypes = {
  action: scenarioActionDataShape.isRequired,
  device: deviceDataShape,
  showActionButtons: PropTypes.bool,
  disableActionButtons: PropTypes.bool,
  active: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

ActionItem.defaultProps = {
  device: null,
  showActionButtons: false,
  disableActionButtons: false,
  active: false,
  onEdit: null,
  onDelete: null,
};

module.exports = ActionItem;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/scenarios/ActionItem.js